import { WithDefaultLayout } from '@/components/DefautLayout'
import TitleTemp from '@/components/TitleTemp';
import { Page } from '@/types/Page'
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { Popover, Button, Dropdown, MenuProps  } from 'antd';
import React, { useState } from 'react'
import { tenants } from '@/types/BazaarTenant';
const items: MenuProps['items'] = [
  { key: '2024', label: <a>2024</a> },
  { key: '2026', label: <a>2026 (Coming Soon)</a> }
];

const Home = ({ selectYear, setSelectedYear }: { selectYear: number, setSelectedYear: (year: number) => void }) => {
    const handleMenuClick: MenuProps['onClick'] = (e) => {
        setSelectedYear(parseInt(e.key))
    };
    return (
        <div className="relative h-[500px] overflow-hidden w-full">
            <img alt="indexpict" className='object-cover w-full h-full' src="/images/Bazaar.webp" />
            <div className="absolute inset-0 bg-gray-900 opacity-70"></div>
            <div className="absolute inset-0 flex justify-center items-center px-8 ">
                <div className="justify-center px-8">
                    <div className="text-white text-center max-w-5xl">
                        <h1 className="flex items-center justify-center text-2xl md:text-5xl font-bold mb-4 text-white gap-2 flex-wrap">
                        <span className='whitespace-nowrap'>Fuel Your Fun at Our Bazaar</span>
                        <span className="inline-flex items-center space-x-1">
                        <span>{selectYear}</span>
                            <Dropdown menu={{ items, onClick: handleMenuClick }} trigger={['click']}>
                            <Button
                            className="text-white font-bold w-6 h-6 flex items-center justify-center bg-defaultBlue hover:bg-darkBlue border-0"
                            icon={<FontAwesomeIcon icon={faChevronDown} style={{ fontSize: '0.75rem' }} />}
                            />
                            </Dropdown>
                        </span>
                        </h1>

                        <div className="mb-4">
                            <p>Recharge at our vibrant food and beverage bazaar!</p>
                            <p className='mb-4'>Enjoy a wide selection of delicious eats, refreshing drinks, and tasty treats</p>

                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const TenantsView = ({ year }: { year: number }) => {
    const filteredTenants = tenants.filter(t => t.year === year);
    filteredTenants.sort((a, b) => b.menu.length - a.menu.length);

    if (filteredTenants.length === 0) {
    return (
      <div className="w-full flex flex-col justify-center items-center">
        <a className="text-center text-white cursor-pointer p-3 bg-defaultBlue  font-semibold rounded-md mr-2" onClick={() => {window.dispatchEvent(new CustomEvent("open-whatsapp-popup"));}}>Be our tenant, Contact us now!</a>
      </div>
    );
  }

    return (
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  gap-5 w-[80%]'>
            {filteredTenants.map((tenant, index) => (
                <div className="w-full  bg-white shadow-md rounded relative  border border-defaultBlue overflow-hidden" key={index}>
                    <Popover content={<p>{tenant.location}</p>} trigger="click" placement="top">
                        <div className="w-10 h-10 rounded-bl-md flex items-center justify-center bg-darkBlue absolute top-0 right-0 shadow cursor-pointer">
                            <FontAwesomeIcon icon={faMapMarkerAlt} style={{ fontSize: '1.25rem', color: 'white' }} />
                        </div>
                    </Popover>
                    <div className='w-full h-52 flex items-center justify-center mt-5'>
                        <div className='w-52 h-52 relative rounded-full overflow-hidden shadow-md hover:scale-105 transition-all duration-300'>
                            {tenant.image != undefined ? 
                                <img alt={tenant.name} src={tenant.image} className='w-full h-full object-cover' /> 
                                :
                                <div className='bg-darkBlue w-full h-full flex items-center justify-center'>
                                    <h1 className='text-center font-bold text-white text-xl'>{tenant.name}</h1>
                                </div>
                            }
                        </div>
                    </div>

                    <div className='p-5 flex items-center flex-col'>
                        <h1 className='font-semibold text-xl mb-2'>{tenant.name}</h1>
                        <ul className="flex flex-wrap gap-2 items-center justify-center">
                            {tenant.menu.map((menu, index) => (
                                <li key={index} className=" w-auto rounded-full border border-defaultBlue px-2 py-1">
                                    {menu}
                                </li>
                            ))}
                        </ul>

                    </div>
                </div>
            ))}
        </div>
    )
}

const Render = () => {
    const [selectYear, setSelectYear] = useState<number>(2026);
    return (
        <div className='flex flex-col items-center'>
            <Home selectYear={selectYear} setSelectedYear={setSelectYear} />
            <TitleTemp name={'Booths'} />
            <TenantsView year={selectYear} />
        </div>
    );
}

const iitBazaar: Page = () => {
    return (
        <div>
            {Render()}
        </div>
    );
}

iitBazaar.layout = WithDefaultLayout;
export default iitBazaar
